import { ButtonRoundLg } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { ROUTE_UNIT_NOTES } from '@apps-radionet-portal-root/src/config/private-routes'

interface IProps {
  loading?: boolean
  unit?: IUnitGenericDetailsModel
}

export const UnitNotesNavigateButton: React.FC<IProps> = ({ loading, unit }) => {
  const navigation = useNavigation()

  return (
    <ButtonRoundLg
      type='button'
      loading={loading || !unit}
      className='action-brand'
      callback={() =>
        navigation.navigateForward({ route: ROUTE_UNIT_NOTES, routeUrl: ROUTE_UNIT_NOTES.buildPath(unit?.status, unit?.unitId) })
      }
      tooltip={{
        id: 'unit-navigate-notes',
        message: 'Device notes',
        place: 'bottom'
      }}
    >
      <commonIcons.notes className='text-[1.1em]' />
    </ButtonRoundLg>
  )
}
